import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import FormErrors from "./FormErrors";

const FormWrapper = ({ children, formErrors = null, onCancel, onSubmit }) => (
  <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-[24px] tw-min-w-[640px]">
    {formErrors && <FormErrors formErrors={formErrors} />}
    {children}

    <div className="tw-flex tw-justify-end tw-gap-[8px]">
      <Button size="medium" schema="tertiary" onClick={onCancel}>
        Cancel
      </Button>

      <Button size="medium" onClick={onSubmit}>
        Submit
      </Button>
    </div>
  </div>
);

FormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  formErrors: PropTypes.shape(),
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default FormWrapper;
